var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 160",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2948_12922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0C35.8174 0 0 35.8174 0 80C0 124.183 35.8174 160 80 160C124.183 160 160 124.183 160 80C159.947 35.8393 124.161 0.051022 80 0ZM80 145.454C43.8497 145.454 14.5461 116.15 14.5461 80C14.5461 43.8497 43.8497 14.5461 80 14.5461C116.15 14.5461 145.454 43.8497 145.454 80C145.41 116.131 116.131 145.41 80 145.454Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2703 76.9893V36.3636C87.2703 32.3475 84.0146 29.0918 79.9984 29.0918C75.9822 29.0918 72.7266 32.3475 72.7266 36.3636V79.9996C72.7266 81.9287 73.4943 83.7776 74.8573 85.1406L96.6753 106.959C99.5641 109.75 104.168 109.67 106.96 106.781C109.681 103.963 109.681 99.4948 106.96 96.6765L87.2727 76.9893H87.2703Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2948_12922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.07758b4f.svg";
export { ForwardRef as ReactComponent };